/*
  <free-shipping-bar> custom element.

  Used to be a progress bar; now it's a pack-only confirmation ribbon
  rendered from snippets/free-shipping-bar.liquid. The element is always
  in the DOM (initial visibility set server-side); this JS keeps it in
  sync with live cart mutations so the ribbon appears/disappears as the
  user adds or removes the last non-pack item.

  Rule: visible iff cart has at least one pack line (item.properties._glend_pack)
        and zero non-pack lines.
*/
if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      this.trySubscribe();
      this.fetchAndUpdate();
    }

    trySubscribe() {
      var self = this;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData) {
            self.updateVisibility(event.cartData);
          } else {
            self.fetchAndUpdate();
          }
        });
      } else {
        setTimeout(function () { self.trySubscribe(); }, 500);
      }
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    fetchAndUpdate() {
      var self = this;
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(function (data) { self.updateVisibility(data); })
        .catch(function (err) { console.error('Pack ribbon error:', err); });
    }

    updateVisibility(cart) {
      var hasPack = false;
      var hasNonPack = false;
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (it.properties && it.properties._glend_pack) {
          hasPack = true;
        } else {
          hasNonPack = true;
        }
      }
      var packOnly = hasPack && !hasNonPack;
      this.style.display = packOnly ? '' : 'none';
      this.classList.toggle('is-visible', packOnly);
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}
